<template>
  <!-- 高德地图 -->
  <el-card class="map" :body-style="{ padding: 0 }">
    <div class="" v-if="isError">当前浏览器不支持高德地图</div>
    <div id="a-map" :style="aMap.style" v-if="!isError" />
    <div class="toolbar">
      <el-button v-if="changed" @click="goBack"> 返回原始位置 </el-button>
    </div>
  </el-card>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, defineProps } from 'vue'
import { ORI_LNG_LAT, ORG_INFORMATION } from '@/config/constant.js'
import LOGO_IMG from '@/assets/images/logo-title.png'

const props = defineProps({
  center: {
    type: Array,
    default: () => ORI_LNG_LAT
  },
  info: {
    type: String,
    default: `
    <div class="fs-lg px-2 py-2">
    <div class="text-primary mb-2 fs-xl">${ORG_INFORMATION.name}</div>
    </div>
    `
    // <div>电话 : ${ORG_INFORMATION.phone}</div>
    // <div class="my-1">邮箱 : ${ORG_INFORMATION.email}</div>
    // <div>地址 : ${ORG_INFORMATION.address}</div>
  }
})
const isError = ref(false)
const changed = ref(false) //地图是否缩放或者移动
const zoom = 13
const { AMap = null } = window
if (!AMap) isError.value = true

const aMap = reactive({
  instance: null,
  infoWindow: null,
  style: {
    height: '400px',
    width: '100%'
  }
})

const closeInfoWindow = () => {
  aMap.instance.clearInfoWindow()
}

const createInfoWindow = (title, content) => {
  var info = document.createElement('div')
  info.className = 'custom-info input-card content-window-card'

  //可以通过下面的方式修改自定义窗体的宽高
  //info.style.width = "400px";
  // 定义顶部标题
  var top = document.createElement('div')
  var titleD = document.createElement('div')
  var closeX = document.createElement('img')
  top.className = 'info-top'
  titleD.innerHTML = title
  closeX.src = 'https://webapi.amap.com/images/close2.gif'
  closeX.onclick = closeInfoWindow

  top.appendChild(titleD)
  top.appendChild(closeX)
  info.appendChild(top)

  // 定义中部内容
  var middle = document.createElement('div')
  middle.className = 'info-middle'
  middle.style.backgroundColor = 'white'
  middle.innerHTML = content
  info.appendChild(middle)

  // 定义底部内容
  var bottom = document.createElement('div')
  bottom.className = 'info-bottom'
  bottom.style.position = 'relative'
  bottom.style.top = '0px'
  bottom.style.margin = '0 auto'
  var sharp = document.createElement('img')
  sharp.src = 'https://webapi.amap.com/images/sharp.png'
  bottom.appendChild(sharp)
  info.appendChild(bottom)
  return info
}

const initMap = () => {
  //定义地图中心点坐标
  // const center = new AMap.LatLng(39.98412, 116.307484)
  //定义map变量，调用 TMap.Map() 构造函数创建地图
  const map = new AMap.Map('a-map', {
    resizeEnable: true,
    center: props.center
    // zoom
  })
  map.setZoom(zoom)
  //marker
  const marker = new AMap.Marker({
    map,
    // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: props.center
    // offset: new AMap.Pixel(-13, -30)
  })

  //info
  const title = `${ORG_INFORMATION.name}`
  const content = []
  content.push(
    `<img style="width: 100px" src='https://gimg2.baidu.com/image_search/src=http%3A%2F%2Ftalent.sciencenet.cn%2Fupload%2F2021%2F20210719113625793.png&refer=http%3A%2F%2Ftalent.sciencenet.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1658499002&t=afac1ce3ab547130cb950737dc00d51d'>地址: ${ORG_INFORMATION.address}`
  )
  content.push(`邮箱: ${ORG_INFORMATION.email}`)
  content.push(`电话: ${ORG_INFORMATION.phone}`)

  const infoWindow = new AMap.InfoWindow({
    isCustom: true,
    content: createInfoWindow(title, content.join('<br />')),
    offset: new AMap.Pixel(16, -45)
  })

  AMap.event.addListener(marker, 'click', function () {
    infoWindow.open(map, marker.getPosition())
  })
  infoWindow.open(map, map.getCenter())
  map.on('mapmove', () => {
    changed.value = true
  })
  map.on('zoomchange', () => {
    if (map.getZoom() === zoom) return
    changed.value = true
  })
  aMap.instance = map
  aMap.infoWindow = infoWindow
}

//返回原始位置
const goBack = () => {
  aMap.instance.setCenter(props.center)
  aMap.instance.setZoom(zoom)
  aMap.infoWindow.open(aMap.instance)
  let timer = setTimeout(() => {
    changed.value = false
    clearTimeout(timer)
    timer = null
  }, 1000)
}

onMounted(() => {
  initMap()
})
onBeforeUnmount(() => {
  if (aMap.instance) aMap.instance.destroy()
})
</script>

<style>
.amap-logo,
.amap-copyright {
  display: none !important;
}
</style>

<style lang="scss">
.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}

.map {
  position: relative;
  .toolbar {
    position: absolute;
    right: 30px;
    bottom: 10px;
    z-index: 999;
    width: 100px;
    height: 50px;
  }
}

.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: 400px;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  border: solid 1px silver;
}

div.info-top {
  position: relative;
  background: none repeat scroll 0 0 #f9f9f9;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
}

div.info-top div {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

span {
  margin-left: 5px;
  font-size: 11px;
}

.info-middle img {
  float: left;
  margin-right: 6px;
}
</style>
